<template>
  <v-card v-if="showCard" id="import-modal-requires-dict-card" class="pb-1">
    <v-card-title>
      {{ $t(`views.imports.importModal.importModalRequiresDictCard.title`) }}
    </v-card-title>

    <v-card-text class="py-0 mb-0 mt-2">
      <div class="pt-2 pb-2">
        <ApiErrorAlert ref="apiErrorAlert" :error="errorCode" />

        <template v-if="dictRequiredLength">
          <p class="mb-4" :class="{ 'white--text': $vuetify.theme.dark }">
            {{ $t(`views.imports.importModal.importModalRequiresDictCard.description`) }}
          </p>
          <v-alert
            :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softInfo'"
            icon="mdi-information"
          >
            <strong>
              {{ $t(`views.imports.importModal.importModalRequiresDictCard.onlyOnce`) }}
            </strong>
          </v-alert>
        </template>
        <template v-if="!dictRequiredLength && dictInDictLength">
          <v-alert
            :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softInfo'"
            icon="mdi-information"
          >
            <strong>
              {{ $t(`views.imports.importModal.importModalRequiresDictCard.onlyInDict`) }}
            </strong>
          </v-alert>
        </template>
      </div>

      <v-form>
        <v-row>
          <template v-if="dictRequiredLength">
            <v-col
              v-for="(dictPos, idx) in myTmpImport.dict.required"
              :key="`dict-required-${idx}`"
              cols="12"
              md="12"
              class="pt-0"
            >
              <v-card
                class="import-modal-requires-dict-card-dict-card ma-0 px-4 pt-2 pb-4 elevation-0"
                :class="{ filled: isFilled(dictPos) }"
                :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softBackgroundGrey'"
              >
                <div class="items-flex justify-between">
                  <div>
                    <div
                      v-for="importFieldKey in Object.keys(dictPos.importFields)"
                      :key="importFieldKey"
                      class="mb-2"
                      :class="{
                        'import-modal-requires-dict-card-dict-card-title-skipped': dictPos.skip,
                      }"
                    >
                      <span class="import-modal-requires-dict-card-dict-card-key">
                        {{ importFieldKey }}:
                      </span>
                      <span class="ml-0">{{ dictPos.importFields[importFieldKey] }}</span>
                    </div>
                  </div>

                  <div class="items-flex align-start">
                    <v-switch
                      v-model="dictPos.skip"
                      :disabled="loading"
                      :label="
                        $t(`views.imports.importModal.importModalRequiresDictCard.skipDict.skip`)
                      "
                      hide-details
                      class="mt-0"
                      :color="
                        $vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'darkBackgroundGrey'
                      "
                      small
                      @change="(skip) => toogleSkipDict(idx, skip)"
                    ></v-switch>
                    <div class="import-modal-requires-dict-card-skip-info">
                      <InfoIcon
                        :size="15"
                        :text="
                          $t(`views.imports.importModal.importModalRequiresDictCard.skipDict.info`)
                        "
                      />
                    </div>
                  </div>
                </div>

                <template v-if="!dictPos.skip">
                  <div class="import-modal-requires-dict-card-select-data-from-position mb-1">
                    <v-menu
                      v-model="getDataFromPositionActive[idx]"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="400px"
                      content-class="elevation-1"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <a class="primary--text" v-bind="attrs" v-on="on">
                          {{ $t(`views.watchList.watchModal.watchForm.getDataFromPosition`) }}
                        </a>
                      </template>
                      <v-card class="pt-3 pb-4 px-4 my-0">
                        <PositionSearch
                          v-if="getDataFromPositionActive[idx] && showCard"
                          ref="positionSearch"
                          :disabled="loading"
                          @input="(data) => getDataFromPosition(idx, data)"
                        />
                      </v-card>
                    </v-menu>
                  </div>

                  <ImportPositionFieldForm
                    :position.sync="dictPos.positionFields"
                    :loading="loading"
                  />
                </template>
              </v-card>
            </v-col>
          </template>

          <template v-if="dictInDictLength">
            <v-col cols="12" md="12" class="pt-1 pb-3">
              <a
                class="import-modal-requires-dict-card-showindict"
                @click="showInDict = !showInDict"
              >
                {{
                  !showInDict
                    ? $t(`views.imports.importModal.importModalRequiresDictCard.showInDict`)
                    : $t(`views.imports.importModal.importModalRequiresDictCard.hideInDict`)
                }}
                <v-icon color="primary">
                  {{ !showInDict ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                </v-icon>
              </a>
            </v-col>
            <template v-if="showInDict">
              <v-col
                v-for="(dictPos, idx) in myTmpImport.dict.inDict"
                :key="`dict-inDict-${idx}`"
                cols="12"
                md="12"
                class="pt-0"
              >
                <v-card
                  class="import-modal-requires-dict-card-dict-card ma-0 px-4 pt-2 pb-4 elevation-0"
                  :class="{ filled: isFilled(dictPos) }"
                  :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softBackgroundGrey'"
                >
                  <div
                    v-for="importFieldKey in Object.keys(dictPos.importFields)"
                    :key="importFieldKey"
                    class="mb-2"
                  >
                    <span class="import-modal-requires-dict-card-dict-card-key">
                      {{ importFieldKey }}:
                    </span>
                    <span class="ml-0">{{ dictPos.importFields[importFieldKey] }}</span>
                  </div>
                  <ImportPositionFieldForm
                    :position.sync="dictPos.positionFields"
                    :loading="loading"
                    isImportPositionFormInDict
                  />
                </v-card>
              </v-col>
            </template>
          </template>
        </v-row>
      </v-form>

      <v-alert
        v-if="saveDisabled"
        color="softInfo"
        icon="mdi-pencil-outline"
        class="mb-0 mt-4 py-1"
      >
        <strong>
          {{ $t('views.imports.importModal.importModalRequiresDictCard.saveDisabledAlert') }}
        </strong>
      </v-alert>
    </v-card-text>
    <v-card-actions class="mt-3">
      <v-spacer />
      <v-btn
        class="mr-1"
        text
        :disabled="loading"
        :small="$vuetify.breakpoint.smAndDown"
        @click="$emit('close')"
      >
        {{ $t('common.cancel') }}
      </v-btn>
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="saveDisabled"
        :small="$vuetify.breakpoint.smAndDown"
        @click="completeImport"
      >
        {{ $t('views.imports.importModal.importModalRequiresDictCard.continue') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import { completeImport } from '@/lib/api'
import PositionModalMixin from '@/views/components/common/positions/PositionModalMixin'
import ApiErrorAlert from '@/views/components/common/ApiErrorAlert'
import ImportPositionFieldForm from '@/views/components/imports/importModal/ImportPositionFieldForm'
import InfoIcon from '@/views/components/common/InfoIcon'
import PositionSearch from '@/views/components/common/PositionSearch'
import gtag from '@/lib/gtag'

export default {
  components: {
    ApiErrorAlert,
    ImportPositionFieldForm,
    InfoIcon,
    PositionSearch,
  },
  mixins: [PositionModalMixin],
  props: {
    myImport: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    errorCode: null,
    showInDict: false,
    myTmpImport: {},
    getDataFromPositionActive: [],
    // myImport: {
    //   _id: '623b577d310256ccbcb18a07',
    //   userId: '60c0feffb89c9ec99cd58635',
    //   broker: '622b3dabfec1adeb4d866d48',
    //   type: 'order',
    //   method: 'csv',
    //   status: 'requiresDict',
    //   dict: {
    //     required: [
    //       {
    //         importFields: { Producto: 'ALIBABA GROUP HOLDING', 'Bolsa de': 'NSY' },
    //         // positionFields: ['type', 'ticker', 'country', 'exchange'],
    //         positionFields: {
    //           type: null,
    //           ticker: null,
    //           country: null,
    //           currency: null,
    //           exchange: null,
    //         },
    //       },
    //     ],
    //     inDict: [
    //       {
    //         importFields: { Producto: 'MCDONALDS CORP', 'Bolsa de': 'NSY' },
    //         // positionFields: ['type', 'ticker', 'country', 'exchange'],
    //         positionFields: {
    //           type: 'stock',
    //           ticker: 'MCD',
    //           country: 'US',
    //           currency: 'USD',
    //           exchange: 'NYSE',
    //         },
    //       },
    //     ],
    //   },
    // },
  }),
  computed: {
    ...mapState(['user']),
    showCard() {
      return this.myTmpImport.status === 'requiresDict'
    },
    saveDisabled() {
      const requiredNotFilled = this.myTmpImport.dict.required.some((elem) => {
        return !elem.skip && this.positionNotCompleted(elem.positionFields)
      })
      const inDictNotFilled = this.myTmpImport.dict.inDict.some((elem) => {
        return !elem.skip && this.positionNotCompleted(elem.positionFields)
      })
      return requiredNotFilled || inDictNotFilled
    },
    dictRequiredLength() {
      return (
        this.myTmpImport.dict &&
        this.myTmpImport.dict.required &&
        this.myTmpImport.dict.required.length
      )
    },
    dictInDictLength() {
      return (
        this.myTmpImport.dict && this.myTmpImport.dict.inDict && this.myTmpImport.dict.inDict.length
      )
    },
  },
  watch: {
    myImport: {
      handler() {
        this.myTmpImport = JSON.parse(JSON.stringify(this.myImport))

        if (this.showCard)
          gtag.pageview({
            pagePath: `/input/${
              this.type === 'order' ? 'orders' : 'dividends'
            }/import/requiresDict`,
            pageTitle: `input|${
              this.type === 'order' ? 'orders' : 'dividends'
            }|import|requiresDict`,
            pageContentGroup: 'modal',
          })
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async completeImport() {
      try {
        this.loading = true
        const dict = {
          required: this.myTmpImport.dict.required.filter((elem) => {
            return !elem.skip
          }),
          inDict: this.myTmpImport.dict.inDict,
        }
        const result = await completeImport({
          _id: this.myTmpImport._id,
          dict,
        })

        this.$emit('update:myImport', result.data)

        if (this.showCard)
          gtag.pageview({
            pagePath: `/input/${
              this.type === 'order' ? 'orders' : 'dividends'
            }/import/complete/success`,
            pageTitle: `input|${
              this.type === 'order' ? 'orders' : 'dividends'
            }|import|complete|success`,
            pageContentGroup: 'modal',
          })
      } catch (error) {
        this.errorCode = get(error, 'data.name', null)
        if (!this.errorCode) {
          this.$root.$snackbar.error({ text: this.$t('common.saveError') })
        } else {
          this.$refs.apiErrorAlert.scrollToError()
        }

        gtag.pageview({
          pagePath: `/input/${
            this.type === 'order' ? 'orders' : 'dividends'
          }/import/complete/error`,
          pageTitle: `input|${
            this.type === 'order' ? 'orders' : 'dividends'
          }|import|complete|error`,
          pageContentGroup: 'modal',
        })
      }
      this.loading = false
    },
    getDataFromPosition(idx, data) {
      this.getDataFromPositionActive[idx] = false
      if (data) {
        this.myTmpImport.dict.required[idx].positionFields.type = get(data, 'type', undefined)
        this.myTmpImport.dict.required[idx].positionFields.ticker = get(data, 'ticker', undefined)

        // time out to skip watchers (same in PositionForm)

        setTimeout(() => {
          this.myTmpImport.dict.required[idx].positionFields.country = get(
            data,
            'country',
            undefined
          )
        }, 100)

        setTimeout(() => {
          this.myTmpImport.dict.required[idx].positionFields.currency = get(
            data,
            'currency',
            undefined
          )
          this.myTmpImport.dict.required[idx].positionFields.exchange = get(
            data,
            'exchange',
            undefined
          )
        }, 300)
      }
    },
    isFilled(elem) {
      return elem.skip || !this.positionNotCompleted(elem.positionFields)
    },
    toogleSkipDict(idx, skip) {
      const tmp = JSON.parse(JSON.stringify(this.myTmpImport))
      if (!skip) delete tmp.dict.required[idx].skip
      else tmp.dict.required[idx].skip = true
      this.$set(this, 'myTmpImport', tmp)
    },
  },
}
</script>

<style lang="scss">
#import-modal-requires-dict-card {
  p {
    font-size: 15px;
  }
  .items-flex {
    display: flex;
    &.justify-between {
      justify-content: space-between;
    }
    &.align-start {
      align-items: flex-start;
    }
  }
  .import-modal-requires-dict-card-dict-card {
    font-size: 14px;
    font-weight: 300;
    &.filled {
      background-color: #f4f9f6 !important;
    }
  }
  .import-modal-requires-dict-card-showindict {
    font-size: 13px;
  }
  .import-modal-requires-dict-card-skip-info {
    margin-top: 2px;
    margin-left: 6px;
  }
  .import-modal-requires-dict-card-dict-card-title-skipped {
    color: rgba(0, 0, 0, 0.4);
  }
  .import-modal-requires-dict-card-dict-card-key {
    text-transform: capitalize;
  }

  .import-modal-requires-dict-card-select-data-from-position a {
    font-size: 14px;
  }
}
.theme--dark {
  #import-modal-requires-dict-card {
    .import-modal-requires-dict-card-dict-card-title-skipped {
      color: rgb(255, 255, 255, 0.4);
    }
    .import-modal-requires-dict-card-dict-card {
      &.filled {
        background-color: #053015 !important;
      }
    }
  }
}
</style>
